import React, { useEffect, useState } from 'react'
import Spinwheel from '../Spinwheel';
import ReactSelect from 'react-select';
import { cityByCountryApi, countryListApi } from '../../../utils/ApiEndpointFunctions';
import { useAdminContext } from '../../../context/adminContext';
import DatePicker from 'react-datepicker';

function AddDiscountFormModal({ formik, addLoader, modalId, countryOptions }) {
  
  // const [countryOptions, setCountryOptions] = useState([])
  const [cityOptions, setCityOptions] = useState([])
 const {adminDetail} = useAdminContext();

  const filterCites = async (countryId) => {
    try {
      const res = await cityByCountryApi("", countryId)
      if (res.status === 200) {
        let cityOption = res.data?.data?.map(ele => ({ label: ele.name, value: ele.id }))
        setCityOptions(cityOption);
      }

    } catch (error) {
      console.log(error)
    }
  };

  console.log("f errr",formik.errors)

  const handleCountryChange = (country) => {

    setCityOptions([])
    formik.setFieldValue('countryId', country);
    formik.setFieldValue('cityId', {});

    filterCites(country.value)
  }

  const handleCityChange = (city) => {
    formik.setFieldValue('cityId', city)
  }

  // Helper function to combine date and time into a single Date object
  const combineDateTime = (date, time) => {
    if (!date || !time) return null;
    const combined = new Date(date);
    const timeDate = new Date(time);
    combined.setHours(timeDate.getHours());
    combined.setMinutes(timeDate.getMinutes());
    return combined;
  };

  // Helper function to extract time as Date object for time picker
  const extractTimeAsDate = (dateTime) => {
    if (!dateTime) return null;
    const date = new Date(dateTime);
    const timeOnly = new Date();
    timeOnly.setHours(date.getHours());
    timeOnly.setMinutes(date.getMinutes());
    timeOnly.setSeconds(0);
    timeOnly.setMilliseconds(0);
    return timeOnly;
  };

  // Handle date change for from/to fields
  const handleDateChange = (field, date) => {
    const currentDateTime = formik.values[field] ? new Date(formik.values[field]) : null;
    const currentTime = currentDateTime ? extractTimeAsDate(currentDateTime) : new Date();
    const combined = combineDateTime(date, currentTime);
    formik.setFieldValue(field, combined);
  };

  // Handle time change for from/to fields
  const handleTimeChange = (field, time) => {
    const currentDateTime = formik.values[field] ? new Date(formik.values[field]) : new Date();
    const combined = combineDateTime(currentDateTime, time);
    formik.setFieldValue(field, combined);
  };

  useEffect(() => {
    adminDetail.countryId && filterCites(adminDetail.countryId)
  }, [])

  return (
    <>
      <div
        className="modal fade"
        id={modalId}
        tabIndex="-1"
        aria-labelledby="deleteModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog  modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0">
              <button
                id="confirmModalCloseBtn"
                type="button"
                className="btn-close block-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body pe-0 ps-0">
              <div className="container">
                <h2>Promotional Discount</h2>
                <form onSubmit={formik?.handleSubmit} >

                  <div className="mb-3">
                    <label htmlFor="city" className="form-label">Country</label>
                    <ReactSelect options={countryOptions} value={formik?.values?.countryId} isDisabled={formik?.values?.id || adminDetail.role !== "superAdmin"} onChange={handleCountryChange} onBlur={formik?.handleBlur} noOptionsMessage={() => 'No Countries Available'} />
                    {formik?.touched?.countryId && formik?.errors?.countryId ? (<div className='req-error'>{formik?.errors?.countryId}</div>) : null}
                  </div>

                  <div className="mb-3">
                    <label htmlFor="city" className="form-label">City</label>
                    <ReactSelect options={cityOptions} isDisabled={!formik?.values?.countryId || formik?.values?.id} value={formik?.values?.cityId?.label ? formik?.values?.cityId : null} onChange={handleCityChange} onBlur={formik?.handleBlur} noOptionsMessage={() => 'No Cities Available'} />
                    {formik?.touched?.cityId && formik?.errors?.cityId ? (<div className='req-error'>{formik?.errors?.cityId}</div>) : null}
                  </div>

                  <div className='row '>
                    <div className="mb-3">
                      <label htmlFor="discount" className="form-label">Discount(%)</label>
                      <input type="text" className="form-control" id="discount" placeholder="Enter period name" name='discount' value={formik?.values?.discount} onChange={formik?.handleChange} onBlur={formik?.handleBlur} />
                      {formik?.touched?.discount && formik?.errors?.discount ? (<div className='req-error'>{formik?.errors?.discount}</div>) : null}
                    </div>

                    <label htmlFor='from' className="col-form-label">From</label>
                    <div className='d-flex gap-3'>
                      <div className="mb-3 flex-grow-1 d-flex flex-column">
                        <label className="form-label">Date</label>
                        <DatePicker
                          className='form-control'
                          name="fromDate"
                          dateFormat="dd/MM/yyyy"
                          placeholderText="dd/MM/yyyy"
                          selected={
                            formik.values?.from && !isNaN(new Date(formik.values?.from))
                              ? new Date(formik.values.from)
                              : null
                          }
                          onChange={(date) => handleDateChange("from", date)}
                        />
                      </div>
                      <div className="mb-3 d-flex flex-column">
                        <label className="form-label">Time</label>
                        <DatePicker
                          selected={extractTimeAsDate(formik.values?.from)}
                          onChange={(time) => handleTimeChange("from", time)}
                          showTimeSelect
                          showTimeSelectOnly
                          timeIntervals={15}
                          timeCaption="Time"
                          dateFormat="h:mm aa"
                          className="form-control"
                        />
                      </div>
                    </div>
                    {formik.touched?.from && formik.errors?.from ? (<div className='req-error'>{formik?.errors?.from}</div>) : null}

                    <label htmlFor='to' className="col-form-label">To</label>
                    <div className='d-flex gap-3'>
                      <div className="mb-3 flex-grow-1 d-flex flex-column">
                        <label className="form-label">Date</label>
                        <DatePicker
                          className='form-control'
                          name='toDate'
                          dateFormat="dd/MM/yyyy"
                          placeholderText="dd/MM/yyyy"
                          selected={
                            formik.values?.to && !isNaN(new Date(formik.values?.to))
                              ? new Date(formik.values.to)
                              : null
                          }
                          onChange={(date) => handleDateChange("to", date)}
                        />
                      </div>
                      <div className="mb-3 d-flex flex-column">
                        <label className="form-label">Time</label>
                        <DatePicker
                          selected={extractTimeAsDate(formik.values?.to)}
                          onChange={(time) => handleTimeChange("to", time)}
                          showTimeSelect
                          showTimeSelectOnly
                          timeIntervals={15}
                          timeCaption="Time"
                          dateFormat="h:mm aa"
                          className="form-control"
                        />
                      </div>
                    </div>
                    {formik.touched?.to && formik.errors?.to ? (<div className='req-error'>{formik?.errors?.to}</div>) : null}

                    {/* <div className="mb-3">
                      <label htmlFor="noOfTrips" className="form-label">No. of Trips</label>
                      <input type="number" className="form-control" id="noOfTrips" placeholder="Enter period name" name='noOfTrips' value={formik?.values?.noOfTrips} onChange={formik?.handleChange} onBlur={formik?.handleBlur} onWheel={(e) => e.target.blur()} />
                      {formik?.touched?.noOfTrips && formik?.errors?.noOfTrips ? (<div className='req-error'>{formik?.errors?.noOfTrips}</div>) : null}
                    </div> */}
                  </div>
                  
                  <button type="submit" disabled={addLoader} className="btn btn-primary">
                    {addLoader ? <Spinwheel sizeClass={"spin-small"} /> : "Submit"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default AddDiscountFormModal